import { splitLines, unquote } from '../detect.js';
const ENTITY_RE = /^\s*(\S+)\s*(?:\[\s*"?([^\]]+?)?"?\s*\])?\s*$/;
const RELATION_RE = /^\s*(\S+)\s+(\|[o\}\-]\-[\-o\|\{\.]+|[\|o\}]\-\-[\-o\|\{\}]+|<\||\|\>|\}\-|o\-\-o|}\|--\|\{|\|\.\.\|)\s+(\S+)\s*(?::\s*(.+))?\s*$/;
const CARDINALITY_MAP = {};
export const parseErDiagram = (source) => {
    const lines = splitLines(source);
    const entities = new Map();
    const edges = [];
    const attributes = new Map();
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^erDiagram/i.test(line))
            continue;
        const rel = RELATION_RE.exec(line);
        if (rel) {
            const [, leftEntity, op, rightEntity, label] = rel;
            const leftLabel = leftEntity.split(/\s+/).pop() ?? leftEntity;
            const rightLabel = rightEntity.split(/\s+/).shift() ?? rightEntity;
            edges.push({
                id: `e_${edges.length}_${leftLabel}_${rightLabel}`,
                from: leftLabel,
                to: rightLabel,
                label: unquote((label ?? '').trim()),
            });
            if (!entities.has(leftLabel))
                entities.set(leftLabel, { id: leftLabel, label: leftLabel, shape: 'rect' });
            if (!entities.has(rightLabel))
                entities.set(rightLabel, { id: rightLabel, label: rightLabel, shape: 'rect' });
            continue;
        }
        const ent = ENTITY_RE.exec(line);
        if (ent) {
            const id = ent[1];
            const label = ent[2] ?? id;
            if (!entities.has(id))
                entities.set(id, { id, label: unquote(label), shape: 'rect' });
        }
    }
    return {
        type: 'er',
        nodes: Array.from(entities.values()),
        edges,
        groups: [],
        styles: {},
        meta: { attributes: Array.from(attributes.values()).flat() },
    };
};
//# sourceMappingURL=er.js.map